import React, {Component} from 'react';
import './global.css';
import NavBar from './NavBar';
import PageFooter from './PageFooter';

let _this;

class ContactUs extends Component {
    constructor(props, context) {
        super(props, context);
        _this = this;
        this.state = { formSent: false, formError: false };
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {
        // setCurrentScreen(analytics, window.location.pathname);
        // logEvent(analytics, 'screen_view')
    }

    handleSubmit(e) {
        e.preventDefault();
        const form = e.target;
        const data = new FormData(form);
        // Replace the action URL with your Formspree endpoint: https://formspree.io/f/YOUR_FORM_ID
        fetch(form.action, {
            method: 'POST',
            body: data,
            headers: { Accept: 'application/json' },
        })
            .then(res => {
                if (res.ok) {
                    _this.setState({ formSent: true, formError: false });
                    form.reset();
                } else {
                    _this.setState({ formError: true });
                }
            })
            .catch(() => _this.setState({ formError: true }));
    }

    render() {
        const { formSent, formError } = this.state;
        return (
          <div className="container">
            <NavBar navigate={this.props.navigate} current="ContactUs" />
            <br />
            <p className="normal">
              <h1>Product Support And Feedback</h1>
            </p>
            <br />
            <div className="card" id="shellWhite">
              <div id="content">
                <h2 className="policy">Send Us a Message</h2>
                {formSent && (
                  <p style={{ color: "green" }}>
                    Thank you! Your message has been sent.
                  </p>
                )}
                {formError && (
                  <p style={{ color: "red" }}>
                    Something went wrong. Please email us directly at{" "}
                    <a href="mailto:support@answersolutions.net">
                      support@answersolutions.net
                    </a>
                    .
                  </p>
                )}
                {/* Replace action URL with your Formspree endpoint before deploying */}
                <form
                  action="https://formspree.io/f/mwvwppjy"
                  method="POST"
                  onSubmit={this.handleSubmit}
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "12px",
                    maxWidth: "480px"
                  }}
                >
                  <label>
                    Your name
                    <input
                      type="text"
                      name="name"
                      required
                      placeholder="Jane Smith"
                      style={{
                        display: "block",
                        width: "100%",
                        padding: "8px",
                        marginTop: "4px"
                      }}
                    />
                  </label>
                  <label>
                    Your email
                    <input
                      type="email"
                      name="email"
                      required
                      placeholder="you@example.com"
                      style={{
                        display: "block",
                        width: "100%",
                        padding: "8px",
                        marginTop: "4px"
                      }}
                    />
                  </label>
                  <label>
                    Category
                    <select
                      name="category"
                      style={{
                        display: "block",
                        width: "100%",
                        padding: "8px",
                        marginTop: "4px"
                      }}
                    >
                      <option value="support">Support / Issue</option>
                      <option value="feedback">Feedback / Suggestion</option>
                      <option value="sales">Business Inquiry</option>
                    </select>
                  </label>
                  <label>
                    Message
                    <textarea
                      name="message"
                      required
                      rows="5"
                      placeholder="Describe your issue or suggestion..."
                      style={{
                        display: "block",
                        width: "100%",
                        padding: "8px",
                        marginTop: "4px"
                      }}
                    />
                  </label>
                  <button
                    type="submit"
                    style={{ padding: "10px 24px", cursor: "pointer" }}
                  >
                    Send Message
                  </button>
                </form>
              </div>
            </div>
            <br />
            <div className="card" id="shellWhite">
              <div id="content">
                <h2 className="policy">Contact Us Directly</h2>
                <p>
                  Support:{" "}
                  <a href="mailto:support@answersolutions.net?subject=A Call Recorder App">
                    support@answersolutions.net
                  </a>
                </p>
                <p>
                  Feedback:{" "}
                  <a href="mailto:feedback@answersolutions.net?subject=A Call Recorder App">
                    feedback@answersolutions.net
                  </a>
                </p>
                <p>
                  Business:{" "}
                  <a href="mailto:sales@answersolutions.net?subject=A Call Recorder App">
                    sales@answersolutions.net
                  </a>
                </p>
              </div>
            </div>
            <br />
            <PageFooter navigate={this.props.navigate} current="ContactUs" />
            <br />
          </div>
        );
    }
}

export default ContactUs;
